import React from "react";

const RoleUpdateCountContext = React.createContext();

export default RoleUpdateCountContext;
